/**
 * Nguồn dữ liệu dự toán tùy chỉnh báo cáo
 * pqkhanh 09.08.2024
 */
export default {
  CST: 1,
  CHI_TX: 2,
  CHI_CTMT: 3,
  CHI_DAUTU: 4,
  CHI_PHI_LEPHI: 5,
  CHI_HDSNDV: 6,
  CHI_KHAC: 7,

  THU_NSNN: 8,
  THU_HDSNDV: 9,
  THU_PHI_LEPHI: 10,
  THU_KHAC: 11,
}